import React, { Component } from 'react';  

class NavigatorMain extends Component {
  state = {
    flag: navigator.userAgent.toLowerCase()
  }


  render() {
    let { flag } = this.state
    return (
      <div style={{paddingBottom: flag.indexOf("miniprogram") != -1 ? this.props.children.props.isPaddingBottom==0 ? this.props.children.props.isPaddingBottom : 44 : 0}}>
        {
          flag.indexOf("miniprogram") != -1 ? this.props.children : flag.indexOf("amcfmapp") != -1 || flag.indexOf("hxcfH5WX") != -1 || flag.match(/MicroMessenger/i)=="micromessenger"? null : this.props.children
        }
      </div>
    )
  }
}

export default NavigatorMain;


// WEBPACK FOOTER //
// ./src/components/NavigatorMain.js